export default "__VITE_ASSET__Dggt$lII__"